// index.js or main file
import React, { Suspense, lazy, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Login from './pages/login/login';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import USER from './pages/dddUI/user';

// Each stage ships multi-MB map SVGs, so load pages on demand instead of in the first bundle.
const ThankYou = lazy(() => import('./pages/thankyou/thankyou'));
const Stage1 = lazy(() => import('./pages/game/Stage1'));
const Stage2 = lazy(() => import('./pages/game/Stage2'));
const Stage3 = lazy(() => import('./pages/game/Stage3'));
const Stage4 = lazy(() => import('./pages/game/Stage4'));
const Stage5 = lazy(() => import('./pages/game/Stage5'));
const Stage6 = lazy(() => import('./pages/game/Stage6'));
const Leaderboard = lazy(() => import('./pages/leaderboard/Leaderboard'));
const Intro = lazy(() => import('./pages/intro/intro'));

// Benign Chrome warning when modals/route changes trigger ResizeObserver in the same frame.
const RESIZE_OBSERVER_LOOP = /ResizeObserver loop/;
window.addEventListener(
  'error',
  (event) => {
    if (RESIZE_OBSERVER_LOOP.test(event.message ?? '')) {
      event.stopImmediatePropagation();
    }
  },
  true
);

function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    if (
      location.pathname === "/" ||
      location.pathname.startsWith("/login") ||
      location.pathname.startsWith("/intro") ||
      location.pathname.startsWith("/stage1") ||
      location.pathname.startsWith("/stage2") ||
      location.pathname.startsWith("/stage3") ||
      location.pathname.startsWith("/stage4") ||
      location.pathname.startsWith("/stage5") ||
      location.pathname.startsWith("/stage6") ||
      location.pathname.startsWith("/thankyou") ||
      location.pathname.startsWith("/leaderboard")
    ) {
      body.classList.remove("common-bg");
    } else {
      body.classList.add("common-bg");
    }
  }, [location]);
}

function App() {
  usePageBackground();

  return (
    <Provider store={store}>
      <Routes>

        <Route path="*" element={
          <USER>
            <Suspense fallback={<div style={{ color: '#fff', textAlign: 'center', padding: '40vh 0' }}>Loading…</div>}>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/intro" element={<Intro />} />
              <Route path="/stage1" element={<Stage1 />} />
              <Route path="/welcome" element={<Navigate to="/stage1" replace />} />
              <Route path="/stage2" element={<Stage2 />} />
              <Route path="/stage3" element={<Stage3 />} />
              <Route path="/stage4" element={<Stage4 />} />
              <Route path="/stage5" element={<Stage5 />} />
              <Route path="/stage6" element={<Stage6 />} />
              <Route path="/game" element={<Navigate to="/stage1" replace />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/thankyou" element={<ThankYou />} />
            </Routes>
            </Suspense>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
